import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './Platform_Module_Config_S.css';

const Platform_Module_Config_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Platform Module Configuration');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/Platform_Module_Config', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/Platform_Module_Config',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [PLATFORM_MODULE_CONFIG, setPLATFORM_MODULE_CONFIG] = React.useState(null);
  const [PLATFORM_MODULE_CONFIG_S, setPLATFORM_MODULE_CONFIG_S] = React.useState(null);

  var Ids = [];
  for(var Ele in PLATFORM_MODULE_CONFIG_S){
	  for(var Sec in PLATFORM_MODULE_CONFIG_S[Ele]){
			if(Sec == "id")
				Ids.push(PLATFORM_MODULE_CONFIG_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(PLATFORM_MODULE_CONFIG_S[Ele]["status"]);
			else if(Array.isArray(PLATFORM_MODULE_CONFIG_S[Ele][Sec]))
				  for(var Row in PLATFORM_MODULE_CONFIG_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in PLATFORM_MODULE_CONFIG_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG`).then((response) => {
      setPLATFORM_MODULE_CONFIG(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setPLATFORM_MODULE_CONFIG_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!PLATFORM_MODULE_CONFIG_S) return <div>Loading...</div>;

 const handleLastDataPLATFORM_MODULE_CONFIG_S = async (data) => {
  };




  const handleAddPLATFORM_MODULE_CONFIG_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG_S', JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PLATFORM_MODULE_CONFIG_S');
      setPLATFORM_MODULE_CONFIG_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0"]=value;
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1"]=value;
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2"]=value;
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
  }; 
  

  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["2"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("2","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["4"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("4","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["4"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1"]=value ? true : false; // optionally just use boolean
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("4","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["5"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0"]=value;
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("5","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG(Temp_Data);
    setPLATFORM_MODULE_CONFIG(Temp_Data);
	//handleAddPLATFORM_MODULE_CONFIG(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG']);
  }; 
  

    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1"]=value;
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2"]=value;
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3"]=value;
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PLATFORM_MODULE_CONFIG_S));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4"]=value;
	//handleAddPLATFORM_MODULE_CONFIG_S(Temp_Data,App_Data['PLATFORM_MODULE_CONFIG_S']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4",value,Temp_Data);
 	//handleLastDataPLATFORM_MODULE_CONFIG_S(Temp_Data);
    setPLATFORM_MODULE_CONFIG_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = PLATFORM_MODULE_CONFIG_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Platform Module Configuration')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Module Config ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0" type="text" className="form-control" placeholder="Module Config ID"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Module Config ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '60ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Module Code`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1" type="text" className="form-control" placeholder="Module Code"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '60ch' }}>
						 {t(`Enter Module Code`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Module Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2" type="text" className="form-control" placeholder="Module Name"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Module Name`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Module Category`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3"   onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3_Change} className="form-control" name="Module Category"  >
						  <option value="Core">Core</option>
						  <option value="Compliance">Compliance</option>
						  <option value="Asset">Asset</option>
						  <option value="Offering">Offering</option>
						  <option value="Escrow">Escrow</option>
						  <option value="Investor">Investor</option>
						  <option value="Reporting">Reporting</option>
						  <option value="Operations">Operations</option>
						  <option value="Admin">Admin</option>
						  <option value="Token Subsystem">Token Subsystem</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Module Category
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Enabled`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["1"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4"] === "true" || PLATFORM_MODULE_CONFIG_S?.["1"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To RENT INCOME TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0"] === "true" || PLATFORM_MODULE_CONFIG_S?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To REVENUE SHARE TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1"] === "true" || PLATFORM_MODULE_CONFIG_S?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To SALE PROFIT TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2"] === "true" || PLATFORM_MODULE_CONFIG_S?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To EQUITY APPRECIATION TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3"] === "true" || PLATFORM_MODULE_CONFIG_S?.["2"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To PREFERRED EQUITY TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0"] === "true" || PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To COMMON EQUITY TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1"] === "true" || PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To DEBT NOTE TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2"] === "true" || PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To HYBRID TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3"] === "true" || PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To PRE AUCTION POOL TOKEN`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4"] === "true" || PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Applies To POST AUCTION TOKENIZATION`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5"] === "true" || PLATFORM_MODULE_CONFIG_S?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Requires Admin Approval`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["4"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0"] === "true" || PLATFORM_MODULE_CONFIG_S?.["4"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Requires Compliance Approval`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1_Change} 
					  checked={PLATFORM_MODULE_CONFIG_S?.["4"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1"] === "true" || PLATFORM_MODULE_CONFIG_S?.["4"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '2000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Description`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0" type="text" className="form-control" placeholder="Description"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '2000ch' }}>
						 {t(`Enter Description`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0"   onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Module Config ID`)}</th>
                        <th>{t(`Module Code`)}</th>
                        <th>{t(`Module Name`)}</th>
                        <th>{t(`Module Category`)}</th>
                        <th>{t(`Enabled`)}</th>
                        <th>{t(`Applies To RENT INCOME TOKEN`)}</th>
                        <th>{t(`Applies To REVENUE SHARE TOKEN`)}</th>
                        <th>{t(`Applies To SALE PROFIT TOKEN`)}</th>
                        <th>{t(`Applies To EQUITY APPRECIATION TOKEN`)}</th>
                        <th>{t(`Applies To PREFERRED EQUITY TOKEN`)}</th>
                        <th>{t(`Applies To COMMON EQUITY TOKEN`)}</th>
                        <th>{t(`Applies To DEBT NOTE TOKEN`)}</th>
                        <th>{t(`Applies To HYBRID TOKEN`)}</th>
                        <th>{t(`Applies To PRE AUCTION POOL TOKEN`)}</th>
                        <th>{t(`Applies To POST AUCTION TOKENIZATION`)}</th>
                        <th>{t(`Requires Admin Approval`)}</th>
                        <th>{t(`Requires Compliance Approval`)}</th>
                        <th>{t(`Description`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {PLATFORM_MODULE_CONFIG_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_2"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_3"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_1_4"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_2"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_2_3"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_2"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_3"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_4"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_3_5"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_4_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_5_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_0"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_1"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_2"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_3"]} </td>
						<td>{e["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_PLATFORM_MODULE_CONFIG_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default Platform_Module_Config_S;  